import { render, staticRenderFns } from "./ObjectSelect.vue?vue&type=template&id=06aad7fa&lang=pug&"
import script from "./ObjectSelect.vue?vue&type=script&lang=ts&"
export * from "./ObjectSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports